import React from 'react';
import Button from '../../forms/Button';
import SelectionActions from '../tables/SelectionActions';
import SearchIcon from '@material-ui/icons/Search';

const ActionBar = props => (
    <div
        className={`ckp-admin-action-bar ${props.className ? props.className : ''} ${props.enableSearch || !props.title ? 'ckp-admin-action-bar--flex-end' : ''}`}
    >
        {props.title && <h1 className="ckp-ts-h1 ckp-admin-action-bar-title">{props.title}</h1>}
        <div className={`ckp-admin-action-bar-actions `}>
            {props.buttonAction && !props.selection.length ? (
                <p className="ckp-admin-action-bar-button-frame">
                    <Button
                        onClick={props.buttonAction}
                        className="ckp-admin-action-bar-button"
                        label={props.buttonLabel}
                        loading={props.buttonLoading}
                        inactive={props.buttonInactive}
                    />
                </p>
            ) : null}
            {props.enableSearch ? (
                <div className="ckp-admin-action-bar-search">
                    <SearchIcon />
                    <input onChange={props.search} value={props.searchString} type="text" placeholder="SEARCH..." />
                </div>
            ) : null}
            <SelectionActions
                skipDeleteConfirm={props.skipDeleteConfirm}
                selectionActions={props.selectionActions}
                selectionFunctions={props.selectionFunctions}
                model={props.model}
                selection={props.selection}
                isBusy={props.isBusy}
                deleteAction={props.deleteAction}
            />
        </div>
    </div>
);

ActionBar.defaultProps = { buttonInactive: false, selection: [] };

export default ActionBar;
